import { lazy } from 'react';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

const DocumentSigningPage = Loadable(lazy(() => import('pages/sign-doc')));

// ==============================|| PUBLIC DOCUMENT-SIGNING ROUTES (NO AUTH) ||============================== //

// Sibling of PublicRoutes rather than a child of it: that object's parent path is
// '/sign', so a '/sign-doc/:token' child cannot live under it. Registered in all
// four route trees (staff/talent/client/anon) so the link resolves on every
// subdomain — real signers arrive unauthenticated (anon tree), staff previewing
// the link arrive on the staff tree.
const PublicDocRoutes = {
  path: '/sign-doc',
  element: <CommonLayout />,
  children: [
    {
      path: '/sign-doc/:token',
      element: <DocumentSigningPage />
    }
  ]
};

export default PublicDocRoutes;
